import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UtilsService } from '../services/utils.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(public utilsService: UtilsService, public router: Router) {

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.utilsService.isEmptyObjectOrNullUndefiend(this.utilsService.getLoginUsers())) {
      // window.alert('Access Denied, Login is Required to Access This Page!');
      this.router.navigate(['/auth/login']);
    }
    return true;
  }

}
